module.exports = __webpack_public_path__ + "img/slot-nolimit.55230361.png";